"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _noop = _interopRequireDefault(require("lodash/noop"));

var _context = require("./context");

var _Button = _interopRequireDefault(require("../Button"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _autolinker = require("../../utils/autolinker");

require("./index.css");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function formatUrl(url) {
  if (!url) return '';

  var matchResult = _autolinker.linkify.match(url);

  if (matchResult && matchResult.length === 1 && matchResult[0].index === 0 && matchResult[0].lastIndex === url.length) {
    return matchResult[0].url;
  }

  return url;
}

function LinkPopover(_ref, ref) {
  var _ref$onOpen = _ref.onOpen,
      onOpen = _ref$onOpen === void 0 ? _noop["default"] : _ref$onOpen,
      _ref$onHidden = _ref.onHidden,
      onHidden = _ref$onHidden === void 0 ? _noop["default"] : _ref$onHidden;
  var editor = (0, _context.useEditor)();
  var textNodeRef = (0, _react.useRef)();
  var urlNodeRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)({
    open: false,
    defaultText: '',
    defaultUrl: ''
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var open = state.open,
      defaultText = state.defaultText,
      defaultUrl = state.defaultUrl;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var handleSave = function handleSave() {
    editor.focus();
    var text = textNodeRef.current.value;
    var url = urlNodeRef.current.value;
    var trimmedUrl = url.trim();
    var formattedUrl = formatUrl(trimmedUrl);
    if (!formattedUrl) return;
    var textToDisplay = text.trim() ? text.trim() : trimmedUrl;

    if (editor.selection.isCollapsed()) {
      editor.execCommand('mceInsertContent', false, "<a href=\"".concat(formattedUrl, "\">").concat(textToDisplay, "</a>"));
      return;
    } else {
      editor.execCommand('mceReplaceContent', false, "<a href=\"".concat(formattedUrl, "\">").concat(textToDisplay, "</a>"));
      editor.selection.collapse();
    }
  };

  var handleCancel = function handleCancel() {
    editor && editor.focus();
  };

  (0, _react.useEffect)(function () {
    if (!editor) return;

    var handleFocusIn = function handleFocusIn() {
      setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          open: false
        });
      });
    };

    editor.on('focusin', handleFocusIn);
    return function () {
      editor.off('focusin', handleFocusIn);
    };
  }, [editor]);
  (0, _react.useEffect)(function () {
    if (!open) return;

    var handleEscape = function handleEscape(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        handleCancel();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return function () {
      window.removeEventListener('keydown', handleEscape);
    };
  }, [open]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      show: function show(defaultText, defaultUrl) {
        setState({
          open: true,
          defaultText: defaultText,
          defaultUrl: defaultUrl,
          disabled: !defaultUrl
        });
      },
      hide: function hide() {
        setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            open: false
          });
        });
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!open) onHidden();
  }, [open]);
  if (!open) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Compose-popover p-4 dark:shadow-shallow"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-gray-dark"
  }, defaultUrl ? 'Replace' : 'Insert', " Link Here"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-2 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "insert-link-title",
    className: "w-10 flex-shrink-0"
  }, "Title"), /*#__PURE__*/_react["default"].createElement("input", {
    className: "block w-full bg-transparent",
    ref: textNodeRef,
    id: "insert-link-title",
    placeholder: "Link name",
    autoComplete: "off",
    defaultValue: defaultText,
    autoFocus: !defaultText && open
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-2 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "insert-link-link",
    className: "w-10 flex-shrink-0"
  }, "Link"), /*#__PURE__*/_react["default"].createElement("input", {
    className: "block w-full bg-transparent",
    id: "insert-link-link",
    autoComplete: "off",
    ref: urlNodeRef,
    autoFocus: !!defaultText && open,
    defaultValue: defaultUrl,
    placeholder: "www.example.com",
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        handleSave();
      }
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "small",
    className: "px-2 py-1 mr-2 w-16",
    color: "white",
    onClick: handleCancel
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "small",
    className: "px-2 py-1 w-16",
    onClick: handleSave
  }, t('button.save'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Compose-clear",
    onClick: handleCancel
  }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], {
    fontSize: "small"
  })));
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(LinkPopover);

exports["default"] = _default;
//# sourceMappingURL=LinkPopover.js.map